module.exports = __webpack_public_path__ + "static/media/gmsLogo.0d017d93.svg";